import styled from 'styled-components';
import { _ellipsis } from 'theme/_mixins/mixins';

interface ValueProps {
  active: boolean;
}

export const Container = styled.section`
  background: ${({ theme }) => theme.searchInput.travelArranger.background};
  color: ${({ theme }) => theme.searchInput.travelArranger.label.color};
  box-shadow: ${({ theme }) => theme.searchInput.travelArranger.boxShadow};

  height: ${({ theme }) => theme.searchInput.travelArranger.height};
  max-width: 100%;
  overflow: hidden;
  padding: ${({ theme }) => theme.searchInput.travelArranger.padding};
  position: relative;
  border-radius: 8px;
  border: ${({ theme }) => theme.searchInput.travelArranger.border};
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

export const Content = styled.button`
  flex: 1;
  cursor: pointer;
  background: none;
  text-align: left;
  margin-right: 8px;
  ${_ellipsis()};
`;

export const Label = styled.span`
  position: absolute;
  top: ${({ theme }) => theme.searchInput.travelArranger.detail.top};

  font-size: ${({ theme }) => theme.searchInput.travelArranger.detail.fontSize};
  line-height: unset;
  color: ${({ theme }) => theme.searchInput.travelArranger.detail.color};
  display: ${({ theme }) => theme.searchInput.travelArranger.detail.display};
`;

export const Value = styled.span<ValueProps>`
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.searchInput.travelArranger.label.fontSize};
  ${_ellipsis()};
  line-height: unset;
  color: ${({ theme, active }) =>
    active ? theme.searchInput.travelArranger.label.color : theme.searchInput.travelArranger.placeholder.label.color};
  font-weight: ${({ active }) => (active ? '600' : 'normal')};
  margin-top: ${({ theme }) => theme.searchInput.travelArranger.label.marginTop};
`;

export const GuestTag = styled.p`
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.searchInput.travelArranger.guest.fontSize};
  line-height: 1.29;
  margin-left: 10px;
  font-weight: normal;
  color: ${({ theme }) => theme.searchInput.travelArranger.guest.color};
`;
